import { useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Student must tick to acknowledge booking a session while their assessment is still pending.
export function AssessmentAckDialog({ ack, onClose }) {
  const [ticked, setTicked] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!ack) return null;
  const confirm = async () => {
    setBusy(true);
    try { await ack.retry(); } finally { setBusy(false); setTicked(false); onClose(); }
  };
  return (
    <Dialog open onOpenChange={(o) => { if (!o) { setTicked(false); onClose(); } }}>
      <DialogContent className="bg-[#0F0F0F] border border-[#FF9F1C]/50 max-w-md" data-testid="assessment-ack-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[#FF9F1C]">
            <AlertTriangle className="w-5 h-5" /> Assessment still pending
          </DialogTitle>
          <DialogDescription className="text-sm text-[#E5E5E5] pt-2" data-testid="assessment-ack-message">
            {ack.message}
          </DialogDescription>
        </DialogHeader>
        <label className="flex items-start gap-3 text-sm cursor-pointer select-none mt-2" data-testid="assessment-ack-label">
          <input type="checkbox" checked={ticked} onChange={(e) => setTicked(e.target.checked)}
            className="mt-0.5 w-4 h-4 accent-[#CCFF00]" data-testid="assessment-ack-checkbox" />
          <span>I understand this booking may be cancelled if my assessment isn't completed first.</span>
        </label>
        <div className="flex justify-end gap-2 mt-4">
          <button type="button" onClick={() => { setTicked(false); onClose(); }} data-testid="assessment-ack-cancel"
            className="px-4 py-2 text-xs uppercase tracking-wider text-[#A3A3A3] hover:text-white">Back</button>
          <button type="button" onClick={confirm} disabled={!ticked || busy} data-testid="assessment-ack-confirm"
            className="min-h-[40px] px-4 py-2 text-xs uppercase tracking-wider font-bold bg-[#CCFF00] text-black inline-flex items-center gap-1.5 disabled:opacity-40">
            {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />} Confirm booking
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
